import React from "react";
import { useLocation } from "react-router-dom";
import "../Headers/CountryHeader.css";
import PageURL from "../../constants/PageURL";
import InverterEfficiency from "../inverterEfficiency/InverterEfficiency";
import SCBSMB from "../SCBSMB/SCBSMB";
import ProjOverView from "../projectOverView/ProjOverView";
import PresCripModel from "../prescriptiveModel/PresCripModel";
import LossFlow from "./LossFlow";
import Detailed from "./Detailed";
import Heatmap from "../SCBSMB/Heatmap";
import FaultTree from "../prescriptiveModel/FaultTree";
import GenOverView from "../overviewDetail/GenOverView";
import InverterDeviation from "../inverterEfficiency/InverterDeviation";
import AdminDashboard2 from "../Admin/AdminDashBoard2";
import CountryDefault from "../CountryDefault";
import GenSummaryPred from "../overviewDetail/GenSummaryPred";
import DiagonisticPred from "./DiagonisticPred";
import ScbsmbstringDeviationPred from "../SCBSMB/ScbsmbstringDeviationPred";
import ForecastedPR from "../overviewDetail/ForecastedPR";
import ForecastedAcLineLoss from "../overviewDetail/ForecastedAcLineLoss";
import ForecastPlantAvailability from "../overviewDetail/ForecastPlantAvailability";
import ForecastPlantAvailability2 from "../overviewDetail/ForecastPlantAvailability2";
import PredictiveModuleDegradation from "../predictive/PredictiveModuleDegradation";
import PredictiveModuleHotspot from "../predictive/PredictiveModuleHotspot";
import PredictiveMountingStructure from "../predictive/PredictiveMountingStructure";
import PredictiveConnectorHeating from "../predictive/PredictiveConnectorHeating";
import PredictiveCableInsulation from "../predictive/PredictiveCableInsulation";
import PredictiveTransformerTemperature from "../predictive/PredictiveTransformerTemperature";
import ForecastingSoilingLoss from "../predictive/ForecastingSoilingLoss";
import PredictiveAcCableInsulation from "../predictive/PredictiveAcCableInsulation";
import HeatmapPred from "../SCBSMB/HeatmapPred";

/* ##### Diagnostic component which having all the country related components  ##### */

const Diagonistic = ({
  databaseStr,
  selectedLebel,
  sestSelectedLebel,
  selectedValue,
  setSelectedValue,
  scbsmbDetail,
  setscbsmbDetail,
}) => {
  const location = useLocation();

  return (
    <>
      {location.pathname === PageURL.PROJECT_DETAILS && <CountryDefault />}
      {location.pathname === PageURL.COUNTRYDEFAULT && <CountryDefault />}

      {location.pathname === PageURL.INDIA_LOSS_FLOW && <LossFlow />}
      {location?.pathname === PageURL.INDIA_DIAGONISTIC_DETAILED && (
        <Detailed
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
        />
      )}
      {location?.pathname === PageURL.INDIA_INVERTER_EFFICIENCY && (
        <InverterEfficiency
          selectedValue={selectedValue}
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
          sestSelectedLebel={sestSelectedLebel}
        />
      )}

      {location?.pathname === PageURL.INDIA_INVERTER_DEVIATION && (
        <InverterDeviation
          selectedValue={selectedValue}
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
          sestSelectedLebel={sestSelectedLebel}
        />
      )}
      {location?.pathname === PageURL.INDIA_GEN_SUMMARY && (
        <GenOverView
          selectedValue={selectedValue}
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
        />
      )}
      {/* {location?.pathname === PageURL.INDIA_GEN_SUMMARY && null} */}
      {location?.pathname === PageURL.INDIA_PROJ_OVERVIEW && (
        <ProjOverView databaseStr={databaseStr} />
      )}
      {location?.pathname === PageURL.INDIA_PRES_MODEL_Loss_Flow && (
        <PresCripModel />
      )}
      {location?.pathname === PageURL.INDIA_PRES_MODEL_Fault_Tree && (
        <FaultTree />
      )}
      {location?.pathname === PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM && (
        <Heatmap
          databaseStr={databaseStr}
          scbsmbDetail={scbsmbDetail}
          selectedLebel={selectedLebel}
          sestSelectedLebel={sestSelectedLebel}
        />
      )}

      {location.pathname === PageURL.SCBSMBSTRING_LOSS && (
        <SCBSMB
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          sestSelectedLebel={sestSelectedLebel}
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
        />
      )}
      {location.pathname === PageURL.ADMIN_DASHBOARD && <AdminDashboard2 />}
      {location.pathname === PageURL.GENERATION_SUMMARY_PREDICTIVE && (
        <GenSummaryPred
          selectedValue={selectedValue}
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
        />
      )}
      {location.pathname===PageURL.PREDICTIVE_DROP_IN_PR && <ForecastedPR selectedLebel={selectedLebel} databaseStr={databaseStr}/>}
      {location.pathname===PageURL.PREDICTIVE_LV_AC_CABLE_LOSS && <ForecastedAcLineLoss selectedLebel={selectedLebel} databaseStr={databaseStr}/>}
      {location.pathname===PageURL.PREDICTIVE_INVERTER_AVAILABILITY && <ForecastPlantAvailability selectedLebel={selectedLebel} databaseStr={databaseStr}/> }

      {/* {location.pathname===PageURL.PREDICTIVE_INVERTER_AVAILABILITY && <ForecastPlantAvailability2 selectedLebel={selectedLebel} databaseStr={databaseStr}/> } */}

      {location.pathname === PageURL.PREDICTIVE_MODULE_DEGRADATION && (
  <PredictiveModuleDegradation selectedLebel={selectedLebel} databaseStr={databaseStr} />
)}

{location.pathname === PageURL.PREDICTIVE_MODULE_HOTSPOT && (
  <PredictiveModuleHotspot selectedLebel={selectedLebel} databaseStr={databaseStr} />
)}

{location.pathname === PageURL.PREDICTIVE_MOUNTING_STRUCTURE && (
  <PredictiveMountingStructure selectedLebel={selectedLebel} databaseStr={databaseStr} />
)}

{location.pathname === PageURL.PREDICTIVE_CONNECTOR_HEATING && (
  <PredictiveConnectorHeating selectedLebel={selectedLebel} databaseStr={databaseStr} />
)}

{location.pathname === PageURL.PREDICTIVE_CABLE_INSULATION &&<> (
  <PredictiveCableInsulation selectedLebel={selectedLebel} databaseStr={databaseStr} />
  <PredictiveAcCableInsulation selectedLebel={selectedLebel} databaseStr={databaseStr} />
)</>}

{location.pathname === PageURL.PREDICTIVE_TRANSFORMER_TEMPERATURE && (
  <PredictiveTransformerTemperature selectedLebel={selectedLebel} databaseStr={databaseStr} />
)}

{location.pathname === PageURL.FORECASTING_SOILING_LOSS && (
  <ForecastingSoilingLoss selectedLebel={selectedLebel} databaseStr={databaseStr} />
)}
      
      {location.pathname === PageURL.DIAGONISTIC_DETAILED_PREDICTIVE && (
        <DiagonisticPred
          selectedValue={selectedValue}
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
        />
      )}

      {location.pathname === PageURL.PREDICTIVE_SCBSMBSTRING_LOSS && (
        <ScbsmbstringDeviationPred
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          sestSelectedLebel={sestSelectedLebel}
          selectedLebel={selectedLebel}
          scbsmbDetail={scbsmbDetail}
          setscbsmbDetail={setscbsmbDetail}
          databaseStr={databaseStr}
        />
      )}

         {location?.pathname === PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM && (
        <HeatmapPred
          databaseStr={databaseStr}
          scbsmbDetail={scbsmbDetail}
          selectedLebel={selectedLebel}
          sestSelectedLebel={sestSelectedLebel}
        />
      )}
    </>
  );
};

export default Diagonistic;
